import { propIs } from 'utils';

import { ICartEntry } from '@rbi-ctg/menu';
import { CartEntryType } from 'utils/cart/types';

import { IsCartEntryType } from '../types';

export const isCartEntryCombo = () => propIs<ICartEntry>('type', CartEntryType.combo);

export const isCartEntryWithTypeCombo = isCartEntryCombo() as IsCartEntryType<ICartEntry>;
